import { IAudienceCondition } from 'core/components/shared/ui/VisualAudienceExtended'

export const getNoAudienceAccess = (): IAudienceCondition => ({
  UserRoles: [],
  HpOrg: [],
  Country: [],
  Email: [],
  GeoMarket: [],
})
